export enum IAC_MANAGEMENTS_TABLE_COLUMNS {
  NAME = "name",
  RESOURCES = "resources",
  RESOURCE_ADDRESS = "resourceAddress",
  RESOURCE_TYPE = "resourceType",
  DRIFT_DETECTED = "drifted",
  SPACE = "space",
  VENDOR = "vendor",
  UPDATED_AT = "updatedAt",
  ACTIONS = "rowActions",
}
